import { faArrowUpWideShort, faClock, faDatabase, faFile, faHeart as faHeartSolid, faListCheck, faQuoteLeft, faTag, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { favotiteSet as reducerFavoriteSet } from '../../../reducers/models/widget';
import axios from 'axios';
import ErrorAdd from '../../../util/ErrorAdd';

function WidgetAddModal({ id, number, idObject, widgetModalShow, setWidgetModalShow, allowedAdd, addHandler }) {
    /*
    id - idTask
    allowedAdd - Разрешено добавление
    addHandler - Передает ID добавленного виджета. Для того чтобы перевести его в режим редактирования
    
    idObject:
            1	Задача
            2	Регулярная задача
            6   Регулярная задача. Трекер
            3	Доска
            4	Проект
            5	Пользователь
    */

    const dispatch = useDispatch()

    const stateWidget = useSelector((state) => state.widget);//Виджеты 

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    //Добавит виджет
    function widgetAdd(idWidget) {
        setLog(null);
        setLoading(true);

        var name = null;

        if (idWidget === 4) {
            name = "Текст HTML";
        }
        if (idWidget === 5) {
            name = "Чек-лист";
        }
        if (idWidget === 6) {
            name = "Файлы";
        }
        if (idWidget === 7) {
            name = "Параметры";
        }

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetAdd', { ID_Task: id, ID_Widget: idWidget })
                .then((res) => {
                    if (res.data.Status == 1) {
                        setWidgetModalShow(false);
                        const number = res.data.Data;
                        addHandler({ idWidget: idWidget, number: number });
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetAdd', { ID_TaskR: id, ID_Widget: idWidget })
                .then((res) => {
                    if (res.data.Status == 1) {
                        setWidgetModalShow(false);
                        const number = res.data.Data;
                        addHandler({ idWidget: idWidget, number: number });
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetAdd', { ID_Board_Task: id, ID_Widget: idWidget })
                .then((res) => {
                    if (res.data.Status == 1) {
                        setWidgetModalShow(false);
                        const number = res.data.Data;
                        addHandler({ idWidget: idWidget, number: number });
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }


    function wiggetIcon(id) {
        if (id === 1) {
            return faClock
        }
        if (id === 2) {
            return faArrowUpWideShort
        }
        if (id === 3) {
            return faTag
        }
        if (id === 4) {
            return faQuoteLeft
        }
        if (id === 5) {
            return faListCheck
        }
        if (id === 6) {
            return faFile
        }
        if (id === 7) {
            return faDatabase
        }
    }

    function favoriteSet(idWidget, val) {
        //setLoading(true);
        axios.post('/api_tracker/widget/faworiteSet', { ID_Widget: idWidget, Val: val })
            .then((res) => {
                if (res.data.Status == 1) {
                    dispatch(reducerFavoriteSet({ id_widget: idWidget, val: val }));
                    //setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    //setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={widgetModalShow} onHide={() => setWidgetModalShow(false)} >
                <Modal.Body>
                    <div className="modal_close" onClick={() => setWidgetModalShow(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Список виджетов</div>
                    {id === null ?
                        (
                            <div style={{ minHeight: "100px", textAlign: "center" }} className="fs-4">Для начала работы с виджетами добавьте название задачи</div>
                        )
                        : (
                            allowedAdd === false ?
                                (
                                    <div style={{ minHeight: "100px", textAlign: "center" }} className="fs-4">Для начала работы с виджетами выберите проект</div>
                                )
                                :
                                (
                                    <div className='widget_item_block___'>
                                        <div className="grid-menu grid-menu-xl grid-menu-3col">
                                            <div className="no-gutters row">
                                                {stateWidget.list.filter(a => a.ID_Object === idObject).map(item => (
                                                    <div key={item.ID} className="col-4 text-center">
                                                        <div className='widget_item_block'>
                                                            <FontAwesomeIcon icon={item.Favorite === true ? faHeartSolid : faHeartRegular} className={item.Favorite === false ? 'btn-icon-wrapper btn-icon-sm like' : 'btn-icon-wrapper btn-icon-sm like_active'} onClick={() => favoriteSet(item.ID, !item.Favorite)} />
                                                            <button className="btn-icon-vertical btn-square btn" style={{ paddingTop: '0px' }} onClick={() => widgetAdd(item.ID)}>
                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                    <FontAwesomeIcon icon={wiggetIcon(item.ID)} className="btn-icon-wrapper btn-icon-lg mb-3_" />
                                                                </div>
                                                                {item.Name}
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                                        {loading === true && <div className="loader_01 mt-30"></div>}
                                    </div>
                                )
                        )
                    }
                </Modal.Body>
            </Modal >
        </>
    );
}

export default WidgetAddModal;